export enum Variants {
  NOTHING = 'nothing',
  WAITING = 'waiting',
  DONE = 'done',
};



// WEBPACK FOOTER //
// ./src/components/calendar/text/enums.ts